import type { Dot, Stick } from '@tools/math/Verlet';
import type { LifeCycleEntity } from '@tools/LifeCycle';
import { Snap } from './Snap';
import { Modifier } from './Modifier';

export type Directions = 'left' | 'right' | 'auto';

export class Controls extends Modifier implements LifeCycleEntity {
	private mainDot!: Dot;
	private mainStick!: Stick;

	constructor() {
		super();
		this.lifeCycle.register(this);
	}

	public async load() {
		const connection = this.createConnection('static');
		this.mainDot = connection.dot;
		this.mainDot.pinned = true;
		this.mainStick = connection.stick;

		this.mainStick.stiffness = 0;
	}

	public goto(index: number, direction: Directions = 'auto') {
		const offset = this.state.getOffsetToIndex(index, direction);
		let to = this.state.drag + offset;

		const snap = this.getModifier(Snap);
		if (snap) {
			to = snap.snap(to);
		}

		this.mainStick.stiffness = 0.01;
		this.mainDot.pos.x = to;
		this.takeover();
	}

	public async stop() {
		this.mainStick.stiffness = 0;
	}

	public gotoNext = () => {
		this.goto(this.state.index + 1, 'left');
	};
	public gotoPrev = () => {
		this.goto(this.state.index - 1, 'right');
	};

	public override tick(): void {
		if (this.mainStick.stiffness > 0) {
			this.mainStick.stiffness -= 0.00005;
		}
		if (this.mainStick.stiffness <= 0) {
			this.mainStick.stiffness = 0;
			this.giveback();
		}
	}
}
